"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetRunItemsTableCols = void 0;
exports.datasetRunItemsTableColsWithOptions = datasetRunItemsTableColsWithOptions;
const typeHelpers_1 = require("./typeHelpers");
exports.datasetRunItemsTableCols = [
    {
        name: "Scores (numeric)",
        id: "agg_scores_avg",
        type: "numberObject",
        internal: "agg_scores_avg",
        nullable: true,
    },
    {
        name: "Scores (categorical)",
        id: "agg_score_categories",
        type: "categoryOptions",
        internal: "agg_score_categories",
        options: [], // to be filled in at runtime
        nullable: true,
    },
    {
        name: "Scores (boolean)",
        id: "agg_score_booleans",
        type: "booleanObject",
        internal: "agg_score_booleans",
        nullable: true,
    },
];
function datasetRunItemsTableColsWithOptions(options, cols = exports.datasetRunItemsTableCols) {
    return cols.map((col) => {
        if (col.id === "agg_scores_avg") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_scores_avg ?? []);
        }
        if (col.id === "agg_score_categories") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_score_categories ?? []);
        }
        if (col.id === "agg_score_booleans") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.agg_score_booleans ?? []);
        }
        return col;
    });
}
